import useSWR from 'swr';
import { JSONConfigService } from '../services/jsonConfig';

export let useJSONConfig = (configService: JSONConfigService) => {
  const { data: config } = useSWR('/jsonconfig', configService.getConfig);
  return config;
};
